<template>
  <w-icon-wrapper icon-name='work-dunning-icon'>
    <g
      id="Gruppe_27403"
      data-name="Gruppe 27403"
      clip-path="url(#clip-path)"
    >
      <path
        id="Pfad_60832"
        data-name="Pfad 60832"
        d="M21,18H19V10.24a.487.487,0,0,1-.12.01,5.126,5.126,0,0,1-1.89-.36A.41.41,0,0,1,17,10v8H5V10a6,6,0,0,1,8.78-5.32,4.949,4.949,0,0,1,.56-1.94A7.921,7.921,0,0,0,13,2.26V2A2,2,0,0,0,9,2v.26A7.994,7.994,0,0,0,3,10v8H1a1,1,0,0,0,0,2H6.55a4.475,4.475,0,0,0,8.9,0H21a1,1,0,0,0,0-2M11,22a2.5,2.5,0,0,1-2.45-2h4.9A2.5,2.5,0,0,1,11,22"
        fill='currentColor'
      />
      <path
        id="Pfad_60833"
        data-name="Pfad 60833"
        d="M12.32,14.78a1.926,1.926,0,0,1-1.42-.46,1.983,1.983,0,0,1-.48-1.37h2.07v-.94H10.42v-.77h2.07v-.95H10.43A1.74,1.74,0,0,1,12.35,8.5a3.616,3.616,0,0,1,1.15.2l.22-1.51A6.294,6.294,0,0,0,12.26,7a3.775,3.775,0,0,0-2.61.87,3.341,3.341,0,0,0-1.09,2.42H7.5v.95H8.55v.77H7.5v.94H8.55a3.321,3.321,0,0,0,1,2.44,3.684,3.684,0,0,0,2.58.88,6.92,6.92,0,0,0,1.59-.18l-.22-1.5a3.649,3.649,0,0,1-1.18.19"
        fill='currentColor'
      />
      <path
        id="Pfad_60834"
        data-name="Pfad 60834"
        d="M18.88,0a5.105,5.105,0,0,0-4.54,2.74,4.949,4.949,0,0,0-.56,1.94,3.4,3.4,0,0,0-.03.45,5.127,5.127,0,0,0,5.13,5.12.487.487,0,0,0,.12-.01A5.121,5.121,0,0,0,18.88,0m0,8.59h-.01a.691.691,0,0,1-.69-.69.7.7,0,0,1,.7-.69.69.69,0,1,1,0,1.38m.69-2.77a.7.7,0,0,1-1.39,0V2.35a.7.7,0,0,1,1.39,0Z"
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconDunning' };
</script>
